import { render, staticRenderFns } from "./ResetPasswordExpired.vue?vue&type=template&id=20002d82&"
import script from "./ResetPasswordExpired.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports